module.exports = __webpack_public_path__ + "static/media/subGoogle3.f718f4b4.png";